import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, timer} from 'rxjs';
import {OfflineUnitsStatus} from './offline-units-status';
import {HttpClient} from '@angular/common/http';
import {AuthorizationService} from '../../authorization/authorization.service';
import {concatMap, expand, filter, switchMap, tap} from 'rxjs/operators';
import {OfflineUnitsStatusItem} from './offline-units-status-item';

@Injectable({
  providedIn: 'root'
})
export class OfflineUnitsService {
  currentStatus: BehaviorSubject<OfflineUnitsStatus> = new BehaviorSubject<OfflineUnitsStatus>({
    alarm: false,
    data: []
  });
  private readonly refreshInterval = 20000;

  constructor(
    protected http: HttpClient,
    protected authorizationService: AuthorizationService,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string,
  ) {
    this.authorizationService.isRootOrSuperuser()
      .pipe(
        filter(
          isRootOrSuperuser => isRootOrSuperuser
        )
      )
      .subscribe(
      isRootOrSuperuser => {
        const dataObservable = this.http.get(
          this.environmentApiBasepoint + 'offline-unit',
          {
            observe: 'body'
          }
        ).pipe(
          tap(
            (data: Array<OfflineUnitsStatusItem>) => this.currentStatus.next({
              alarm: data.length > 0,
              data: data
            })
          )
        );
        const dataSubscription = dataObservable.pipe(
          expand(
            () => timer(this.refreshInterval).pipe(concatMap(() => dataObservable))
          )
        ).subscribe();
      }
    );
  }
}
